// Components
import ButtonPill from "../../../../Buttons/ButtonPill";

// Constants
import {RoutePaths} from "../../../../../Constants/RoutePaths";

// Assets
import IconArrowWithTail from "../../../../../Assets/SVGs/Icons/Arrows/ArrowWithTail";
import IconList from "../../../../../Assets/SVGs/Icons/List/List";

// Context
import VideoDTO from "../../../../../Models/DTOs/VideoDTO";

type VideoRedirectsProps = { video: VideoDTO };

function VideoRedirects({ video }: VideoRedirectsProps) {
    return (
        <div className="watch-video__video-redirects">

            {/** Next Episode Button **/}
            { video.NextEpisode !== null && video.NextEpisode !== undefined ? (
                <ButtonPill
                    link={RoutePaths.Watch(video.NextEpisode?.Id)}
                    icon={IconArrowWithTail()}
                    label="Next Episode"
                />
            ) : null}

            {/** 'Go To Series' Button'' **/}
            { video.SeriesId !== null && video.SeriesId !== undefined ? (
                <ButtonPill
                    link={RoutePaths.SeriesEpisodes(video.SeriesId)}
                    icon={IconList()}
                    label="All Episodes"
                />
            ) : null }
        </div>
    )
}

export default VideoRedirects;
